export default function WhatIsCoaching() {
  return (
    <section
      id="what-is-coaching"
      data-testid="what-is-coaching-section"
      className="py-24 md:py-32"
    >
      <div className="max-w-5xl mx-auto px-6 md:px-12 text-center reveal">
        <span className="text-xs md:text-sm uppercase tracking-[0.28em] text-brand-coral font-semibold">
          What is coaching?
        </span>
        <h2 className="mt-6 font-serif text-4xl md:text-5xl lg:text-6xl text-brand-navy leading-tight tracking-tight">
          A <em className="italic text-brand-coral">joyful partnership</em>.
          Structure, focus, and a little laughter when plans go sideways.
        </h2>
        <p className="mt-8 text-lg md:text-xl leading-relaxed text-brand-navy/75 max-w-3xl mx-auto">
          Think of coaching as a partnership: I bring structure, focus, and
          coaching craft; you bring goals, spark, and what matters most.
          Together we create a plan that lets your gifts shine while reducing
          friction in a neurotypical world.
        </p>

        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-6">
          {[
            "Trust",
            "Curiosity",
            "Clear goals",
            "Mutual respect",
            "Willingness to try",
          ].map((word, i) => (
            <div
              key={word}
              data-testid={`partnership-pillar-${i}`}
              className="rounded-2xl bg-white border border-brand-sage/15 px-5 py-6 shadow-[0_6px_22px_rgba(47,66,80,0.04)] hover:-translate-y-1 transition"
            >
              <div className="font-serif text-2xl md:text-3xl text-brand-sageDeep italic">
                {word}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
